export default "__VITE_ASSET__DnD2g$wX__"